const _ = require('lodash');
const { COMP_PFX } = require('./constants');

class ReportCalculatorTableFormatter {
	constructor(calculator) {
		Object.assign(this, calculator, { calculator });
	}

	filterArrayData(arrData, filterFn, maxLevel = null) {
		const { reportData } = this;
		const { groupBy } = reportData.settings;
		let finalLevel = maxLevel;
		if (finalLevel === null) {
			finalLevel = groupBy.length - 1;
		}
		const copy = (originalArray, level = 0, path = []) => {
			const isFinal = (level === finalLevel);
			const remaining = originalArray.map((element) => {
				if (isFinal) {
					return filterFn({ element, path }) ? element : null;
				}
				const children = copy(element.data, level + 1, path.concat(element.label));
				if (!children.length) {
					return null;
				}
				return {
					...element,
					data: children,
					totals: this.calculator.getTotals(children),
				};
			});
			return remaining.filter((e) => e);
		};
		return copy(arrData);
	}

	filterByImportance(rootArray) {
		const importancePercentage = this.settings.importanceTabPerc || 0;
		const { reportData, allDataSums } = this;
		const { sums, groupBy } = reportData.settings;
		const { CALCULATED_SUMS = {} } = this.constants;

		const calcMetric = sums
			.map((sum) => CALCULATED_SUMS[sum])
			.find((calculatedSum) => calculatedSum);
		const metric = calcMetric ? calcMetric.trimBy : allDataSums[0];
		let getter = (o) => o[metric];
		if (reportData.compareToRange) {
			const compMetric = `${COMP_PFX}${metric}`;
			getter = (o) => o[metric] + o[compMetric];
		}

		let all = [];
		// TODO: what does this do?
		// eslint-disable-next-line max-len
		const addObjects = (arr, level = 0) => (level === groupBy.length - 1 ? all.push(...arr) : arr.forEach((e) => addObjects(e.data, level + 1)));
		addObjects(rootArray);
		all = all.map((e) => e.data);
		const total = _.sumBy(all, getter);
		const sorted = _.sortBy(all, getter).reverse();

		let sum = 0;
		let minAccept = 0;
		// TODO: re-write without restricted syntax
		// eslint-disable-next-line no-restricted-syntax
		for (const element of sorted) {
			sum += getter(element);
			if (sum >= (importancePercentage / 100) * total) {
				minAccept = getter(element);
				break;
			}
		}

		const filterFn = ({ element }) => getter(element.data) >= minAccept;
		return this.filterArrayData(rootArray, filterFn);
	}

	filterForUniqueness(arrData) {
		const { groupBy, filterUniqueDimIdx } = this.settings;
		if (groupBy.length === 1) {
			return arrData;
		}
		const labels = new Map();
		const addObjects = (arr, level = 0) => (level === filterUniqueDimIdx
			? arr.forEach(({ label }) => {
				const count = labels.get(label) || 0;
				labels.set(label, count + 1);
			})
			: arr.forEach(({ data }) => addObjects(data, level + 1)));
		addObjects(arrData);
		const filterFn = ({ element }) => labels.get(element.label) === 1;
		return this.filterArrayData(arrData, filterFn, filterUniqueDimIdx);
	}

	getTableFormatted(arrData) {
		const sortDataArray = (dataArray, sortFunction) => {
			const sortedArray = _.sortBy(dataArray, sortFunction);
			return sortedArray.map((dataSet) => {
				const isFinalLevel = !Array.isArray(dataSet.data) || _.isEmpty(dataSet.data);
				return (isFinalLevel)
					? dataSet
					: { ...dataSet, data: sortDataArray(dataSet.data, sortFunction) };
			});
		};

		const calculateElementSumValue = (element, calculateSumVal, sortReversed) => {
			const dataObj = Object.prototype.hasOwnProperty.call(element, 'totals')
				? element.totals
				: element.data;

			const sumValues = calculateSumVal(dataObj);

			return (sortReversed)
				? sumValues * -1
				: sumValues;
		};
		let res = arrData;
		// Filter by importance if needed
		if (this.calculator.isFilteringByImportance()) {
			res = this.filterByImportance(arrData);
		}
		if (this.calculator.isFilteringForUniqueness()) {
			res = this.filterForUniqueness(res);
		}
		// Apply sorting (if set and valid)
		const {
			sortSum, sortReversed, sortSumIsComp, useCompareTo,
		} = this.settings;
		const { sums } = this.reportData.settings;
		if (!sortSum || !sums.includes(sortSum)) {
			return res;
		}
		if (sortSumIsComp && !useCompareTo) {
			return res;
		}

		const calculateSumVal = _.partial(
			(...args) => this.calculator.calculateSumVal(...args),
			_,
			sortSum,
			undefined,
			sortSumIsComp,
		);

		const sortFunction = _.partial(
			calculateElementSumValue,
			_,
			calculateSumVal,
			sortReversed,
		);
		res = sortDataArray(res, sortFunction);
		return res;
	}
}

module.exports = ReportCalculatorTableFormatter;
